// Re-runs the upload pipeline for a Studio video whose transcript failed. The backend doesn't charge
// minutes again for a reprocess.
import { captionsBumpFunctionFor } from './captionsFunctions';

const reprocessTranscript = async ({ user, generatedVideoId, videoTitle, videoQuality, videoDuration, videoSizeMb, videoThumbnail }) => {
    const run = captionsBumpFunctionFor((videoSizeMb || 0) * 1024 ** 2, videoDuration || 0);
    await run({
        videoMetadata: {
            uploadedBy: user.uid,
            videoId: generatedVideoId,
            description: videoTitle,
            videoFileName: videoTitle,
            videoQuality: videoQuality,
            videoDuration: String(videoDuration || 0),
            videoThumbnail: videoThumbnail,
            isReprocess: true
        }
    });
};

export { reprocessTranscript };
